/**
 * High Contrast — the player-enabled accessibility override (NOT admin-
 * assignable). Targets WCAG AAA: near-opaque near-black panels, pure-bright
 * text, a high-luminance accent, no glow/shimmer (the resolver also forces
 * reduce-motion when this is active), and wider heading letter-spacing. Fully
 * replaces whatever theme the story assigned.
 */
export const highContrast = {
  id: 'highContrast',
  name: 'High Contrast',
  assignable: false,
  colorScheme: 'dark',
  mantine: {
    primaryColor: 'cyan',
    fontFamily: 'Rajdhani, sans-serif',
    headings: { fontFamily: 'Orbitron, sans-serif' },
  },
  cssVars: {
    '--bw-bg': '#000000',
    '--bw-body-color': '#ffffff',
    '--bw-panel-bg': 'rgba(8, 10, 14, 0.99)',
    '--bw-panel-border': 'rgba(120, 240, 255, 0.6)',
    '--bw-accent': 'rgba(120, 240, 255, 1)',
    '--bw-glow-color': 'rgba(0, 0, 0, 0)',
    '--bw-glow-text-color': 'rgba(0, 0, 0, 0)',
    '--bw-body-font': "'Rajdhani', sans-serif",
    '--bw-heading-font': "'Orbitron', sans-serif",
    '--bw-heading-letter-spacing': '0.08em',
    '--bw-content-base': '1.1875rem',
  },
}
